export default {
  init() {
	  	$(document).ready(function() {
			  if($(window).width() < '992') {
				  $('.guarantee-subtitle').appendTo('.guarantee-subtitle-mobile');
				  $('.guarantee-text').appendTo('.guarantee-text-mobile');
			  }


			// Reviews Slider
			$('.reviews-slider').owlCarousel({
				loop:true,
				margin:10,
				nav:true,
				dots: true,
				dotsEach: true,
				responsive:{
					0:{
						items:1
					},
					600:{
						items:2
					},
					1000:{
						items:2
					}
				}
			})

			  //Home-beer-slider
			  new BeerSlider( document.getElementById( 'beer-slider' ), {start: 50});


			  // Out nums section statistics
			  const time = 1000;
			  const step = 10;

			  function outNum(num, elem) {
				  let l = document.querySelector(elem + ' span');
				  let n = 0;

				  let t = Math.round(time/(num/step));
				  let interval = setInterval(() => {
					n = n + step;

					if (n == num) {
						clearInterval(interval);
					}

					l.innerHTML = n;
				  },
				  t);
			  }

			  let firstStat = parseInt(($('.statistic-value1').attr('data-stat-first')).replace(/[^\d]/g, ''));
			  let secondStat = parseInt(($('.statistic-value2').attr('data-stat-second')).replace(/[^\d]/g, ''));
			  let thirdStat = parseInt(($('.statistic-value3').attr('data-stat-third')).replace(/[^\d]/g, ''));
			  let fourthStat = parseInt(($('.statistic-value4').attr('data-stat-fourth')).replace(/[^\d]/g, ''));

			  $(window).scroll(function() {
				var wt = $(window).scrollTop();
				var wh = $(window).height();
				var et = $('.statistics').offset().top;
				var eh = $('.statistics').outerHeight();

				var dh = $(document).height();
				if (wt + wh >= et || wh + wt == dh || eh + et < wh){
					$('.statistics').addClass('show-statistics');
				}

				if ($('.statistics').hasClass('show-statistics') && !$('.statistics').hasClass('show-statistics-end')) {
					outNum(firstStat, '.statistic-value1');
					outNum(secondStat, '.statistic-value2');
					outNum(thirdStat, '.statistic-value3');
					outNum(fourthStat, '.statistic-value4');
					$('.statistics').addClass('show-statistics-end');
				}
			});

		})


		// Slogan animation
		$(window).scroll(function() {
			var wt = $(window).scrollTop();
			var wh = $(window).height();
			var et1 = $('.slogan-first-row').offset().top;
			var eh1 = $('.slogan-first-row').outerHeight();
			var et2 = $('.slogan-second-row').offset().top;
			var eh2 = $('.slogan-second-row').outerHeight();
			var et3 = $('.slogan-third-row').offset().top;
			var eh3 = $('.slogan-third-row').outerHeight();

			var dh = $(document).height();
			if (wt + wh >= et1 || wh + wt == dh || eh1 + et1 < wh){
				$('.slogan-first-row').addClass('animated');
			}
			if (wt + wh >= et2 || wh + wt == dh || eh2 + et2 < wh){
				$('.slogan-second-row').addClass('animated');
			}
			if (wt + wh >= et3 || wh + wt == dh || eh3 + et3 < wh){
				$('.slogan-third-row').addClass('animated');
			}
		});

    /**
     * Tooth animate
     */
    var params = {
      container: document.getElementById('lottie'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData
    };

    var paramsTwo = {
        container: document.getElementById('lottieTwo'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
    };

    var paramsThree = {
        container: document.getElementById('lottieThree'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData
    };

    var anim, animTwo, animThree;

    anim = lottie.loadAnimation(params);
    animTwo = lottie.loadAnimation(paramsTwo);
    animThree = lottie.loadAnimation(paramsThree);

  	},

	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
